import { merge } from 'lodash';

export const setListingParents = (action, state) => {
  const { parents } = action;
  const changeInState = {
    data: { parents },
  };
  return merge({}, state, changeInState);
};

export const handleUpdateSingleParent = (state, action) => {
  const { parent } = action;
  if (state.loading) return state;
  const parents = state.data?.parents;

  Object.keys(parents).forEach((key) => {
    if (parents[key].id === parent.id) {
      parents[key] = merge({}, parents[key], parent);
    }
  });

  const changeInState = {
    data: {
      parents,
    },
  };

  return merge({}, state, changeInState);
};

export const handleUpdateParent = (
  state,
  { payload: { data, parentType } }
) => {
  const newState = JSON.parse(JSON.stringify(state));
  newState.data.parents[parentType] = data;
  return newState;
};
